import * as React from 'react';
import { getApiUrl } from '../../../config/api';

import { Box } from '@mui/material';
import { TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import PhoneIcon from '@mui/icons-material/Phone';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';


export default function ParticipantSearch(props) {
    const [options, setOptions] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [hasInitialized, setHasInitialized] = React.useState(false);
    const { threadsCallback, threadsLoadingCallback, initialFilters } = props;

    const optionEqual = (left, right) => {
        return (left.key === right.key);
    }


    const itemChanged = React.useCallback((event, values, reason) => {
        //console.log([event, value, reason]);

        if (isLoading) {
            return; // Prevent multiple simultaneous requests
        }

        if (values.length === 0) {
            threadsCallback({'threads':[]});
            return;
        }

        var v = [];
        values.forEach((vv) => {
            var r = {
                "rule": "any",
                "values": vv.numbers
            }
            v.push(r);
        })

        var rule = {
            "rule": "all",
            "values": v
        }

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify(rule);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
          };

        setIsLoading(true);
        threadsLoadingCallback();
        fetch(getApiUrl("/v1/messages/thread_rules/search"), requestOptions)
          .then(response => response.json())
          .then(result => {
            threadsCallback(result);
            setIsLoading(false);
          })
          .catch(error => {
            console.log('error', error);
            setIsLoading(false);
          });

    }, [threadsCallback, threadsLoadingCallback, isLoading]);

    React.useEffect(() => {
        if (initialFilters && !hasInitialized) {
            setHasInitialized(true);
            itemChanged(null, [{'numbers':[initialFilters]}], null);
        }
    }, [itemChanged, initialFilters, hasInitialized]);

    const inputChanged = (event, newInputValue) => {
        var url = new URL(getApiUrl("/v1/people/search_grouped"));
        url.searchParams.set('query', newInputValue);
        fetch(url).then(
            (response) => { return response.json()}
        ).then(
            (data) => {
                const items = data.data.map((value) => {
                    var icon = <QuestionMarkIcon/>

                    if ( !isNaN(value.numbers[0]) && value.numbers[0].length === 10 ) {
                        icon = <PhoneIcon/>
                    }

                    if (value.name === null) {
                        return {
                            'name' : value.numbers.join(','),
                            'icon' : icon,
                            'numbers' : value.numbers,
                            'key'  : value.numbers[0]
                        }
                    }


                    return {
                        'name': value.name + " (" + value.numbers.join( ',') + ")",
                        'icon': icon,
                        'numbers': value.numbers,
                        'key': value.group
                    };
                });
                setOptions(items); 
            }
        );
    };

    return (
        <Autocomplete
          multiple
          id="tags-standard"
          options={options}
          getOptionLabel={(option) => option.key}
          filterOptions={(x) => x}
          onInputChange={inputChanged}
          onChange={itemChanged}
          isOptionEqualToValue={optionEqual}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label="Participants"
            />
          )}
          renderOption={(props, option) => (
            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                {option.icon}
                <Box>{option.name}</Box>
            </Box>

          )}
        />
    );
  }